import React from "react";
import SaveButton from "./SaveButton";
import EnableEditButton from "./EnableEditButton";
import './_static/Buttons.css';
import BackButton from "./BackButton";
import ReportCreator from "../reports/ReportCreator";
import QrCreator from "../reports/QrCreator";
import QuotationCreator from "../reports/QuotationCreator";
import NextBtkButton from "./NextBtkButton";

function FormButtons(props) {
    return (
        <div className="FormButtons">
            <BackButton/>
            {(props.reportGeneration && props.id) && <ReportCreator id={props.id} label={props.reportGeneration} reportType={props.reportType} preview={false} version={props.priceOfferVersion}/>}
            {(props.reportGeneration && props.id && !props.noReportPreview) && <ReportCreator id={props.id} label={props.reportGeneration} reportType={props.reportType} preview={true} version={props.priceOfferVersion}/>}
            {(props.priceOffer && props.id) && <QuotationCreator id={props.id} label={props.priceOffer} reportType={props.reportType + "Quotation"} version={props.priceOfferVersion}/>}
            {(props.qrGeneration && props.id) && <QrCreator id={props.id} reportType={props.reportType + "Qr"} version={props.priceOfferVersion}/>}
            <SaveButton/>
            {props.nextBtkData && <NextBtkButton data={props.nextBtkData}/>}
            <EnableEditButton setDisable={props.setDisable}
                              newPage={props.newPage}/>
        </div>
    )
}

export default FormButtons
